import formSelect from '../../default/js/modules/form';
import 'select2';

import * as FormValidation from 'formvalidation';
import Bootstrap from 'formvalidation/dist/es6/plugins/Bootstrap';

$(document).ready(function () {
    formSelect();

    $('.btn-square--contact-service label').on('click', function(e) {
        //e.preventDefault();

        if ($(this).hasClass('active')) {
            $('.btn-square--contact-service label').removeClass('active');
            //var HourData = '';
        } else {
            $('.btn-square--contact-service label').removeClass('active');
            $(this).addClass('active');
            //var HourData = $(this).data('hour');
        }
        //$('#rdv-hour input[type=hidden]').val(HourData);
    });

    /* FORM VALIDATION */
    const form = document.getElementById('form-id');
    if (form !== null) {
        var fields = {
            'contact_lead[lead][gender]': {
                validators: {
                    notEmpty: {
                        message: "Civilité obligatoire."
                    },
                }
            },
            'contact_lead[lead][lastname]': {
                validators: {
                    notEmpty: {
                        message: "Nom obligatoire."
                    },
                    stringLength: {
                        max: 80,
                            message: 'Maximum de 80 caractères.'
                    },
                }
            },
            'contact_lead[service]': {
                validators: {
                    notEmpty: {
                        message: "Choix d'un service obligatoire."
                    },
                }
            },
            'contact_lead[lead][firstname]': {
                validators: {
                    notEmpty: {
                        message: "Prénom obligatoire."
                    },
                    stringLength: {
                        max: 80,
                            message: 'Maximum de 80 caractères.'
                    },
                }
            },
            'contact_lead[lead][phone]': {
                validators: {
                    notEmpty: {
                        message: "Le téléphone est obligatoire."
                    },
                    stringLength: {
                        max: 10,
                        min: 10,
                        message: 'Le téléphone doit contenir 10 caractères.'
                    },
                }
            },
            'contact_lead[lead][email]': {
                validators: {
                    notEmpty: {
                        message: "L'adresse email est obligatoire."
                    },
                    emailAddress: {
                        message: "N'est pas une adresse mail valide."
                    }
                }
            },
            'contact_lead[lead][zipcode]': {
                validators: {
                    notEmpty: {
                        message: "Code postal obligatoire."
                    },
                    regexp: {
                        message: "Code postal invalide."
                    }
                }
            },
            'contact_lead[lead][city]': {
                validators: {
                    notEmpty: {
                        message: "Ville obligatoire."
                    },
                }
            },
        };

        if(window.parameters.site.site_code == 'group') {
            fields['contact_lead[agency]'] = {
                validators: {
                    notEmpty: {
                        message: "Choix d'une concession obligatoire."
                    },
                }
            };
        }

        FormValidation.formValidation(form, {
            fields: fields,
            plugins: {
                trigger: new FormValidation.plugins.Trigger(),
                bootstrap: new Bootstrap(),
                submitButton: new FormValidation.plugins.SubmitButton(),
                defaultSubmit: new FormValidation.plugins.DefaultSubmit(),
                /*icon: new FormValidation.plugins.Icon({
                    valid: 'fa fa-check',
                    invalid: 'fa fa-times',
                    validating: 'fa fa-refresh'
                }),*/ //Avec Bootstrap 4, ne pas oublier d'importer une fontIcons
                // declarative
                declarative: new FormValidation.plugins.Declarative({html5Input: true})
            }
        });
    }

});


// WEBPACK FOOTER //
// ./app/Resources/assets/group/js/contact.js